import { useState } from 'react';
import { ICON } from '../../config/icons';

import './SectionCollapseable.scss';

interface SectionCollapseableProps {
  heading: string;
  customHeading?: React.ReactNode;
  children: React.ReactNode;
  mobileOnly?: boolean;
}

export const SectionCollapseable = ({
  heading,
  customHeading,
  children,
  mobileOnly = false,
}: SectionCollapseableProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  const renderHeader = () => {
    if (customHeading) {
      return customHeading;
    }
    return <h3>{heading}</h3>;
  };

  return (
    <div
      className={`section-collapseable ${mobileOnly ? 'mobile-only' : ''} ${isCollapsed ? 'collapsed' : ''}`}
    >
      <div className="collapseable--header" onClick={toggleCollapse}>
        {renderHeader()}
        <div className="toggle-button">
          <img
            src={isCollapsed ? ICON.UI.EXPAND_LESS : ICON.UI.EXPAND_MORE}
            alt={isCollapsed ? 'Expand' : 'Collapse'}
          />
        </div>
      </div>
      <div className={`collapseable--content `}>{children}</div>
    </div>
  );
};
